import { useEffect, useState } from "react";
import { api } from "../lib/api";
import CountdownTimer from "../components/CountdownTimer";
import { mediaUrl } from "../lib/media";

export default function ComingSoon() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/coming-soon").then(r => setItems(r.data)); }, []);
    return (
        <div data-testid="coming-soon-page" className="pt-28 pb-16 mx-auto max-w-[1600px] px-6 lg:px-10">
            <div className="mb-10">
                <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">Coming Soon</h1>
                <p className="text-white/60 mt-2">Upcoming AI originals dropping soon on Apni Dukan AI.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {items.map((c) => (
                    <div
                        key={c.id}
                        data-testid={`coming-card-${c.id}`}
                        className="group relative rounded-[18px] overflow-hidden border border-white/10 bg-white/[0.02]"
                    >
                        <div className="relative aspect-video">
                            <img src={mediaUrl(c.poster)} alt={c.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                            <span className="absolute top-4 left-4 text-[10px] font-bold uppercase tracking-wider bg-[#FFD400] text-black px-2 py-1 rounded">
                                Coming Soon
                            </span>
                        </div>
                        <div className="p-6">
                            <h3 className="font-display font-bold text-2xl text-white">{c.title}</h3>
                            <p className="text-white/60 mt-1">{c.subtitle}</p>
                            <p className="text-sm text-white/50 mt-3 line-clamp-2">{c.description}</p>
                            <div className="mt-5">
                                <CountdownTimer target={c.release_date} testId={`countdown-${c.id}`} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
